// Read-only chips for the Excel pivot filters a pinned table applies (roadmap #188) — shown in
// the import wizard's Tables step and on the dashboard. No inputs: filters can't be edited yet
// (`editable: false` is the hook for that). A filter Boomerang can't apply is still shown, in a
// warning style, with the reason one click away — never hidden.
import React, { useState } from "react";
import { chipsForTable, chipExpandable, chipValues } from "./tableFilters";

const chipBase = {
  display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11, lineHeight: 1.4,
  borderRadius: 999, padding: "2px 9px", border: "1px solid #cbd5e1", background: "#f8fafc", color: "#334155",
};
const chipWarn = { ...chipBase, border: "1px solid #fcd34d", background: "#fffbeb", color: "#92400e" };
const toggleBtn = {
  fontSize: 10.5, fontWeight: 600, padding: 0, border: "none", background: "none", color: "inherit",
  textDecoration: "underline", cursor: "pointer",
};

function Chip({ chip, idx }) {
  const [open, setOpen] = useState(false);
  const unsupported = chip.status === "unsupported";
  const expandable = chipExpandable(chip);
  const detailId = `table-filter-${String(chip.id || idx).replace(/[^a-zA-Z0-9_-]/g, "_")}-${idx}`;
  return (
    <li style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 3 }}>
      <span style={unsupported ? chipWarn : chipBase} title={unsupported ? chip.reason_text || undefined : undefined}>
        {unsupported && <span aria-hidden="true">⚠</span>}
        <span>{chip.label || `${chip.field}: ${chip.summary || ""}`}</span>
        {expandable && (
          <button type="button" style={toggleBtn} aria-expanded={open} aria-controls={detailId}
            onClick={() => setOpen((v) => !v)}>
            {open ? "Hide" : (unsupported ? "Why?" : "Show all")}
          </button>
        )}
      </span>
      {expandable && open && (
        <div id={detailId} style={{ fontSize: 11, color: unsupported ? "#92400e" : "#475569", paddingLeft: 10, lineHeight: 1.45 }}>
          {unsupported ? chip.reason_text : chipValues(chip).join(", ")}
        </div>
      )}
    </li>
  );
}

// `table` = a wizard pinned table (`tableFilters`/`table_filters`) or a dashboard visual
// (`table_filters`). Renders nothing when the table has no Excel filters.
export default function TableFilterChips({ table, style }) {
  const chips = chipsForTable(table);
  if (!chips.length) return null;
  return (
    <ul aria-label="Filters from your Excel pivot"
      style={{ display: "flex", flexWrap: "wrap", gap: 6, margin: "6px 0 0", padding: 0, ...(style || {}) }}>
      {chips.map((c, i) => <Chip key={`${c.id || "f"}-${c.pivot_range || ""}-${i}`} chip={c} idx={i} />)}
    </ul>
  );
}
